// extracted by mini-css-extract-plugin
export var optionGrid = "_aj-7";
export var optionList = "_aj-6";
export var questionsBlock = "_aj-9";
export var spacer = "_aj-5";
export var stepCenteredContent = "_aj-3";
export var stepInner = "_aj-0";
export var stepInnerFullWidth = "_aj-1";
export var stepInnerLockScroll = "_aj-2";
export var stepTransitionFrame = "_aj-4";
export var welcomeBlock = "_aj-8";